/**
 * Shared constants and value mappings for location lists
 */

/**
 * Stock level value mappings for badges
 */
export const STOCK_LEVEL_VALUE_MAPPING = [
	{ value: 'Empty', label: 'Empty', color: { type: 'neutral' } },
	{ value: 'Low', label: 'Low', color: { type: 'neutral' } },
	{
		value: 'Medium',
		label: 'Medium',
		color: { type: 'warning' },
	},
	{ value: 'Full', label: 'Full', color: { type: 'success' } },
] as const;

/**
 * Required fields for basic location lists
 */
export const BASE_REQUIRED_FIELDS = [
	'location._id',
	'location.code',
	'location.description',
	'location.type',
	'location.locationCode',
	'location.capacity',
	'location.units',
	'location.status',
	'location.warehouseId',
];

/**
 * Required fields for merchandiser location lists
 */
export const MERCHANDISER_REQUIRED_FIELDS = [
	'location._id',
	'location.code',
	'location.description',
	'location.type',
	'location.status',
	'location.capacity',
];
